import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import {
  users,
  roles,
  alert,
  confirmPrompt,
  branches,
  ports,
  areas,
  cargoTypes,
  serviceModes,
  containerYards,
  charges,
  chargeServiceMatrix,
  companyPolicies,
  freightRates,
  portRates,
  truckingRates,
  DB,
  DBRole,
  customers,
  roleDetail,
  SQdocuments,
  salesQuotation,
  salesQuotationDocuments,
  vessels,
  voyageSchedule,
  vesselUpdates,
  bookings,
  routes,
  containerVans,
  truckings,
  outbound,
  commodity,
  inbound,
  bookingChange,
  notification,
  calendars,
  waiver,
  croAccounting,
  collection,
  hustling,
  customerRequest,
  overrideCharge,
  siArchive,
} from '../_reducers'

export function configureStore(history, initialState) {
  const reducers = {
    users,
    roles,
    alert,
    confirmPrompt,
    branches,
    ports,
    areas,
    cargoTypes,
    serviceModes,
    containerYards,
    companyPolicies,
    charges,
    freightRates,
    portRates,
    truckingRates,
    chargeServiceMatrix,
    DB,
    DBRole,
    customers,
    roleDetail,
    SQdocuments,
    salesQuotation,
    salesQuotationDocuments,
    vessels,
    voyageSchedule,
    vesselUpdates,
    bookings,
    routes,
    containerVans,
    truckings,
    outbound,
    commodity,
    inbound,
    bookingChange,
    notification,
    calendars,
    waiver,
    croAccounting,
    collection,
    hustling,
    customerRequest,
    overrideCharge,
    siArchive,
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
